import type { BounceGlobalValues } from "@bounce/i18n"

import type { CityData } from "@/libs/bounce/cities/types"
import { defaultPricing } from "@/utils/pricing"

export type BaseCityInterpolations = {
  CITY_MAIN_STORE_LOCATION: string
  CITY_NAME: string
  COUNTRY_NAME: string
  INSURANCE_AMOUNT: string
  LOWEST_PRICE_AMOUNT: string
  LOWEST_PRICE: string
  NUM_CITIES: string
  NUM_LOCATIONS: string
  PRICE_AMOUNT: string
  PRICE_CURRENCY: string
  PRICE: string
  STORAGE_SPOT_COUNT: string
  YEAR: string
}

type GetBaseCityInterpolationsOptions = {
  bounceGlobals: BounceGlobalValues
  city: CityData
  displayRegionName: {
    of: (country: string) => string | undefined
  }
  language: string
  priceInterpolations: {
    price: string
    priceAmount: string
  }
}

export const getBaseCityInterpolations = ({
  city,
  bounceGlobals,
  displayRegionName,
  priceInterpolations,
}: GetBaseCityInterpolationsOptions): BaseCityInterpolations => {
  return {
    CITY_MAIN_STORE_LOCATION: city.mainStore?.gmbAddress?.addressLines || city.translatedName,
    CITY_NAME: city.translatedName,
    COUNTRY_NAME: displayRegionName.of(city.country) || city.country,
    INSURANCE_AMOUNT: bounceGlobals.bounceShieldProtection,
    LOWEST_PRICE_AMOUNT: priceInterpolations.priceAmount,
    LOWEST_PRICE: priceInterpolations.price,
    NUM_CITIES: bounceGlobals.numCities,
    NUM_LOCATIONS: bounceGlobals.numLocations,
    PRICE_AMOUNT: priceInterpolations.priceAmount,
    PRICE_CURRENCY: city.luggagePrice ? city.currency : defaultPricing.defaultCurrency,
    PRICE: priceInterpolations.price,
    STORAGE_SPOT_COUNT: city.storeCount.toString(),
    YEAR: new Date().getFullYear().toString(),
  }
}
